/**
 * Suppress benign ResizeObserver errors that flood the React dev overlay.
 *
 * Browsers fire a global "error" event when a ResizeObserver callback takes
 * longer than one frame. This is purely cosmetic; no functionality is lost.
 * However, CRA's error overlay (injected by webpack *before* user code) picks
 * it up and covers the page in an infinite loop of red error banners.
 *
 * We use three complementary techniques because CRA's overlay handler may be
 * registered before our capture-phase listener:
 *   1. capture-phase addEventListener  – stops later bubble-phase listeners
 *   2. window.onerror                  – returning true marks the error handled
 *   3. preventDefault                  – tells the browser not to log it
 */
if (typeof window !== 'undefined') {
  const noise = [
    'ResizeObserver loop completed with undelivered notifications',
    'ResizeObserver loop limit exceeded',
  ];
  const isNoise = (msg) => noise.some((n) => (msg || '').includes(n));

  window.addEventListener(
    'error',
    (event) => {
      if (isNoise(event?.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );

  const origOnError = window.onerror;
  window.onerror = function (msg, _src, _line, _col, _err) {
    if (isNoise(msg)) return true;
    if (origOnError) return origOnError.apply(this, arguments);
  };
}
